import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = {};
let loading = null;
const listeners = new Set();

export function useSiteImages() {
  const [imgs, setImgs] = useState(cache);
  useEffect(() => {
    const update = () => setImgs({ ...cache });
    listeners.add(update);
    if (!loading) {
      loading = axios
        .get(`${API}/images`)
        .then(({ data }) => {
          cache = data || {};
          listeners.forEach((l) => l());
        })
        .catch(() => {});
    } else {
      loading.then(() => setImgs({ ...cache }));
    }
    return () => listeners.delete(update);
  }, []);
  return imgs;
}

export const pick = (imgs, slot, fallback) => (imgs && imgs[slot]) || fallback;
